import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

export const FAQComponent = () => {

    const [opened, setOpened] = useState();

    const openUnit = (id) => {
        opened === id ? setOpened() : setOpened(id);
    }

    return (
        <div className="faq-container">
            <div className="faq-unit" onClick={() => openUnit(1)}>
                <div className="faq-top">
                    <button className={classNames("disp-button",{"rot-button": opened === 1})}>
                        <FontAwesomeIcon
                            icon={opened === 1 ? faMinus : faPlus}
                        />
                    </button>
                    <div className="faq-question">QUELS SONT LES DÉLAIS DE LIVRAISON?</div>
                </div>

                <div className={classNames("faq-answer", { 'open': opened === 1 })}>
                    Nos délais de livraison sont de 3 heures pour Douala et de 24 heures pour les autres villes.
                </div>
            </div>
            <div className="faq-unit" onClick={() => openUnit(2)}>
                <div className="faq-top">
                    <button className={classNames("disp-button",{"rot-button": opened === 2})}>
                        <FontAwesomeIcon
                            icon={opened === 2 ? faMinus : faPlus}
                        />
                    </button>
                    <div className="faq-question">COMMENT S'EFFECTUE LE PAIEMENT?</div>
                </div>
                <div className={classNames("faq-answer", { 'open': opened === 2 })}>
                    <p>Vous pouvez payer le livreur en espèces ou par MTN momo ou Orange money à la réception de votre commande..</p>
                    <ul>
                        <li>Veuillez vous assurer d'avoir le montant exact du paiement.</li>
                        <li>Nous acceptons uniquement les paiements en FCFA.</li>
                    </ul>
                </div>
            </div>
            <div className="faq-unit" onClick={() => openUnit(3)}>
                <div className="faq-top">
                    <button className={classNames("disp-button",{"rot-button": opened === 3})}>
                        <FontAwesomeIcon
                            icon={opened === 3 ? faMinus : faPlus}
                        />
                    </button>
                    <div className="faq-question">OÙ SOMMES-NOUS SITUÉS?</div>
                </div>
                <div className={classNames("faq-answer", { 'open': opened === 3 })}>
                  Nous sommes situés à <strong>Carrefour Ancient Pharmacie, BONADIBONG, DOUALA</strong>
                </div>
            </div>
            <div className="faq-unit" onClick={() => openUnit(4)}>
                <div className="faq-top">
                    <button className={classNames("disp-button",{"rot-button": opened === 4})}>
                        <FontAwesomeIcon
                            icon={opened === 4 ? faMinus : faPlus}
                        />
                    </button>
                    <div className="faq-question">QUELLE EST LA QUALITÉ DES ARTICLES VENDUS?</div>
                </div>
                <div className={classNames("faq-answer", { 'open': opened === 4 })}>
                    Nous vendons des articles neufs et d'occasion, tous soumis à des contrôles de qualité rigoureux. Nos produits sont 100 % authentiques.
                </div>
            </div>
        </div>
    )
}